<template>
  <div
    v-if="isShow"
    v-loading="loading"
    class="full-page"
    element-loading-text="努力上传中..."
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <el-alert
      type="warning"
      :title="`标红的字段为填写不规范的字段，请点击标红处更改，以免影响后续搜索。一共【${errorNum}】个错误`"
      description="确认上传后，会将正确的数据上传，错误的将推送行政；操作太麻烦可以点击按钮直接全部推送行政制作。"
      :closable="false"
    >
    </el-alert>
    <div class="fix-middle-actions"><el-button circle size="mini" icon="el-icon-close" @click="close"></el-button></div>
    <div v-if="type == 'searchlist'" class="full-page-actions">
      <el-button v-if="!isXZ" size="mini" type="primary" @click="handlePush">推送行政制作</el-button>
      <el-button size="mini" type="primary" @click="showAddField">增加一列</el-button>
      <el-button size="mini" type="primary" @click="delRow">删除行</el-button>
      <el-button type="primary" size="mini" @click="showEditMult">批量修改</el-button>
      <el-button v-if="!isXZ" type="primary" size="mini" style="float:right" @click="confirmData">确认上传</el-button>
      <el-button v-else type="primary" size="mini" style="float:right" @click="xzConfirm">修改完毕</el-button>
    </div>
    <div v-else class="full-page-actions">
      <el-button size="mini" type="primary" @click="showAddField">增加一列</el-button>
      <el-button size="mini" type="primary" @click="delRow">删除行</el-button>
      <el-button type="primary" size="mini" @click="showEditMult">批量修改</el-button>
      <el-button type="primary" size="mini" style="float:right" @click="saveList">处理完毕</el-button>
    </div>
    <div class="full-body">
      <table class="a-table correct-table" cellspacing="0">
        <tr>
          <th style="width:55px"></th>
          <th style="width:30px"><input v-model="isCheckedAll" type="checkbox" @change="onCheckAll" /></th>
          <template v-for="head in heads">
            <th :key="head + 'h'" style="max-width:200px">
              <!-- <el-button type="text" size="mini" icon="el-icon-edit" @click="showEditMult(head)"></el-button><br /> -->
              {{ head }}
            </th>
          </template>
        </tr>
        <tr
          v-for="(tableItem, index) in tableData"
          :key="'item' + index"
          :class="{ 'a-table-row-highlight': tableItem.row == currentRow }"
        >
          <td style="width:55px;text-align:center">{{ tableItem.row }}</td>
          <td style="width:30px;text-align:center">
            <input v-model="tableData[index].checked" type="checkbox" @change="onCheckOne(index)" />
          </td>
          <template v-for="head in heads">
            <td
              v-if="tableItem.comments && tableItem.comments[head]"
              :key="head + 'b'"
              class="td-highlight"
              :title="tableItem.comments[head]"
              style="max-width:200px"
              @click="showEdit(tableItem, head)"
            >
              {{ tableItem[head] }}
            </td>
            <td v-else :key="head + 'b'" :title="tableItem[head]" style="max-width:200px">{{ tableItem[head] }}</td>
          </template>
        </tr>
      </table>
    </div>
    <EditPop ref="EditPop" :on-confirm="handleEditConfirm" :on-remove-tag="handleRemoveTag"></EditPop>
    <SelectFieldPop ref="SelectFieldPop"></SelectFieldPop>
    <ProjectPop ref="ProjectPop" :on-confirm="handleProjectConfirm"></ProjectPop>
    <FavPop ref="FavPop" :on-confirm="handleFavConfirm"></FavPop>
    <CompanyPop ref="CompanyPop" :on-confirm="handleCompanyConfirm"></CompanyPop>
  </div>
</template>
<script>
import EditPop from './edit-pop'
import SelectFieldPop from './select-field-pop'
import ProjectPop from './project-pop'
import FavPop from './fav-pop'
import CompanyPop from './company-pop'

export default {
  components: { EditPop, SelectFieldPop, ProjectPop, FavPop, CompanyPop },
  data() {
    return {
      isShow: false,
      loading: false,
      type: 'searchlist', // list searchlist
      fileMd5: '',
      tableData: [],
      isCheckedAll: false,
      heads: [],
      sheetId: '',
      rightData: [],
      isXZ: false,
      notifyInfo: {},
      currentRow: 0,
      shiftKeyPressed: false,
      lastCheckIndex: '',
      pid: '',
      fids: [],
    }
  },
  computed: {
    errorNum() {
      let num = 0
      this.tableData.forEach(td => {
        if (td.comments) {
          const cNum = Object.keys(td.comments).length
          if (cNum > 0) num += cNum
        }
      })
      return num
    },
  },
  created() {
    this.shiftKeyDown = e => {
      if (e.key === 'Shift') {
        return (this.shiftKeyPressed = true)
      }
    }
    this.shiftKeyUp = e => {
      if (e.key === 'Shift') {
        return (this.shiftKeyPressed = false)
      }
    }
    document.addEventListener('keydown', this.shiftKeyDown)
    return document.addEventListener('keyup', this.shiftKeyUp)
  },
  destroyed() {
    document.removeEventListener('keydown', this.shiftKeyDown)
    return document.removeEventListener('keyup', this.shiftKeyUp)
  },
  methods: {
    show(params) {
      // console.log(params)
      const { records, sheetId, notifyInfo, type, fileMd5 } = params
      this.isXZ = app.user.account == 'HappyLiu'
      this.type = type || 'searchlist'
      if (type === 'list' && !fileMd5) {
        return this.$message.error('没有md5')
      }
      this.fileMd5 = fileMd5 || ''
      this.tableData = records
      this.sheetId = sheetId
      this.rightData = []
      this.notifyInfo = notifyInfo || {}
      this.pid = ''
      this.fids = []
      if (this.tableData.length === 0) {
        this.heads = []
      } else {
        const heads = Object.keys(this.tableData[0])
        this.heads = heads.filter(h => h !== 'comments' && h !== 'row')
      }

      this.isShow = true
    },
    close() {
      this.isShow = false
    },
    onCheckAll() {
      this.tableData = this.tableData.map(dt => {
        dt.checked = this.isCheckedAll
        return dt
      })
    },
    onCheckOne: function(index) {
      if (this.lastCheckIndex !== '') {
        if (this.shiftKeyPressed && this.tableData[index].checked == this.tableData[this.lastCheckIndex].checked) {
          const big = Math.max(this.lastCheckIndex, index)
          const small = Math.min(this.lastCheckIndex, index)
          this.tableData = this.tableData.map((dt, i) => {
            if (i >= small && i <= big) {
              dt.checked = this.tableData[index].checked
            }
            return dt
          })
        }
      }
      this.lastCheckIndex = index
    },
    getChecked: function() {
      return this.tableData.filter(dt => dt.checked)
    },
    delRow() {
      const rows = this.getChecked()
      if (rows.length === 0) {
        return this.$message.info('请先勾选要删除的行')
      }
      this.tableData = this.tableData.filter(dt => !dt.checked)
    },
    showEditMult() {
      let rows = this.getChecked()
      if (rows.length === 0) {
        rows = this.tableData
      }
      this.$refs.SelectFieldPop.show({
        heads: this.heads,
        type: 'edit',
        onConfirm: label => {
          this.$refs.EditPop.show({
            rows,
            label,
          })
        },
      })
    },
    showEdit(tableItem, head) {
      this.currentRow = tableItem.row
      this.$refs.EditPop.show({
        rows: [tableItem],
        label: head,
        value: tableItem[head],
        comment: tableItem.comments[head],
      })
    },
    async handleEditConfirm(params) {
      // console.log(params)
      let { rows, label, value } = params
      if (label === '职能模块') {
        rows = rows.map(row => {
          row[label] = Array.from(new Set(row[label].concat(value)))
          delete row.checked
          return row
        })
      } else {
        rows = rows.map(row => {
          row[label] = value
          delete row.checked
          return row
        })
      }
      const valiRes = await app.service('radish').excelValidate({ data: rows })
      const rowIds = valiRes.data.map(dt => dt.row)
      this.tableData = this.tableData.map((item, index) => {
        if (rowIds.includes(item.row)) {
          item = valiRes.data.filter(dt => dt.row === item.row)[0]
        } else {
        }
        return item
      })
      if (label === '手机' && rows.length === 1 && rows[0]['其他']) {
        this.tableData[0]['其他'] = rows[0].row === this.tableData[0].row ? rows[0]['其他'] : ''
      }
      this.currentRow = 0
    },
    async handleRemoveTag(params) {
      // console.log(params)
      let { rows, label, tag } = params
      rows = rows.map(row => {
        row[label] = row[label].filter(t => t !== tag)
        delete row.checked
        return row
      })
      const valiRes = await app.service('radish').excelValidate({ data: rows })
      const rowIds = valiRes.data.map(dt => dt.row)
      this.tableData = this.tableData.map(item => {
        if (rowIds.includes(item.row)) {
          item = valiRes.data.filter(dt => dt.row === item.row)[0]
        }
        return item
      })
    },
    showAddField() {
      this.$refs.SelectFieldPop.show({ heads: this.heads, type: 'add', onConfirm: this.handleSelectConfirm })
    },
    handleSelectConfirm(field) {
      const arrFields = [
        '地域',
        '职能模块',
        '细分职能',
        '擅长方向',
        '期望行业',
        '期望地域',
        '学历标签',
        '语言标签',
        '香港牌照',
      ]
      this.tableData = this.tableData.map(item => {
        if (arrFields.includes(field)) {
          item[field] = []
        } else {
          item[field] = ''
        }
        return item
      })
      this.heads.unshift(field)
    },
    async pushXz(data) {
      const upData = { status: 'pushed' }
      if (data) {
        upData.data = data
      }
      const res = await app.service('radish').updateSheetsData({ _id: this.sheetId, data: upData })
      if (res.status === 'success') {
        app.service('radish').notifyXingZheng({ sheetId: this.sheetId })
      }
      return res
    },
    async handlePush() {
      const res = await this.pushXz(this.tableData)
      if (res.status === 'success') {
        this.$message.success('推送成功')
        this.close()
        app.root.$refs.radishExcelUpload.close()
      }
    },
    async confirmData() {
      const wrong = this.tableData.filter(item => item.comments)
      if (wrong.length > 0) {
        this.$confirm(`有${wrong.length}条数据不正确`, '提示', {
          confirmButtonText: '仅上传正确数据，错误数据推送行政',
          cancelButtonText: '继续修改',
          type: 'warning',
        })
          .then(async () => {
            const right = this.tableData.filter(item => !item.comments)
            this.rightData = right
            await this.pushXz(wrong)
            if (this.rightData.length > 0) {
              this.$refs.ProjectPop.show()
            } else {
              this.$message.info('没有一条正确数据，错误数据已全部推送行政')
              this.close()
              app.root.$refs.radishExcelUpload.close()
            }
          })
          .catch(() => {})
      } else {
        this.rightData = this.tableData
        if (this.rightData.length > 0) {
          this.$refs.ProjectPop.show()
        } else {
          this.$message.info('没有可上传的数据')
          this.close()
          app.root.$refs.radishExcelUpload.close()
        }
      }
    },
    async xzConfirm() {
      const wrong = this.tableData.filter(item => item.comments)
      if (wrong.length > 0) {
        this.$confirm(`有${wrong.length}条数据不正确`, '提示', {
          confirmButtonText: '继续修改',
          cancelButtonText: '暂时保存，下次接着改',
          type: 'warning',
        })
          .then(() => {})
          .catch(async () => {
            const res = await app
              .service('radish')
              .updateSheetsData({ _id: this.sheetId, data: { data: this.tableData } })
            if (res.status === 'success') {
              this.$message.success('保存成功')
            }
            this.close()
          })
      } else {
        const res = await app
          .service('radish')
          .updateSheetsData({ _id: this.sheetId, data: { status: 'handled', data: this.tableData } })
        if (res.status === 'success') {
          this.$message.success('成功')
        }
        const msg = {
          title: `searchlist修改完毕`,
          text: `searchlist修改完毕：${this.notifyInfo.originalname}`,
          type: 'SL修改',
          link: { sheetId: this.sheetId, from: this.notifyInfo.from },
          account: this.notifyInfo.from,
        }
        app.service('notification').create(msg)
        this.close()
      }
    },
    handleProjectConfirm(pid) {
      this.pid = pid || ''
      this.$refs.FavPop.show()
    },
    handleFavConfirm(fids) {
      this.fids = fids || []
      this.handleConfirm()
    },
    async handleConfirm() {
      const rightData = this.rightData.map(d => {
        delete d.row
        delete d.comments
        return d
      })
      const data = { data: rightData }
      if (this.pid) {
        data.pid = this.pid
      }
      if (this.fids && this.fids.length > 0) {
        data.fids = this.fids
      }
      this.loading = true
      const res = await app.service('radish').sheetsDataDupAndInsert(data)
      if (res.status === 'success') {
        await app.service('radish').updateSheetsData({ _id: this.sheetId, data: { status: 'done' } })
        if (res.data.length > 0) {
          this.$message.info(`上传成功，新增数据${rightData.length}条，重复数据${res.data.length}条`)
          app.root.$refs.DupList.open({ resData: res.data })
        } else {
          this.$message.success(`上传成功，新增数据${rightData.length}条`)
        }
        this.loading = false
        this.close()
        app.root.$refs.radishExcelUpload.close()
      }
    },
    async saveList() {
      const wrong = this.tableData.filter(item => item.comments)
      if (wrong.length > 0) {
        this.$confirm(`有${wrong.length}条数据不正确`, '提示', {
          confirmButtonText: '继续修改',
          cancelButtonText: '暂时保存，下次接着改',
          type: 'warning',
        })
          .then(() => {})
          .catch(async () => {
            const res = await app
              .service('radish')
              .updateSheetsData({ _id: this.sheetId, data: { data: this.tableData } })
            if (res.status === 'success') {
              this.$message.success('保存成功')
            }
            this.close()
          })
      } else {
        const res = await app
          .service('radish')
          .updateSheetsData({ _id: this.sheetId, data: { status: 'handledList', data: this.tableData } })
        this.$refs.CompanyPop.show()
      }
    },
    async handleCompanyConfirm(cid, year) {
      const rightData = this.tableData.map(d => {
        delete d.row
        delete d.comments
        return d
      })
      const res = app.service('company').insertFormerYearsList({ cid, year, table: rightData, fileId: newfile.md5 })
      if (res.status === 'success') {
        // 生成新文件标准list 删除原文件最终list 保存关系
        const newfile = await app.service('file').genStandardXlsx({ oldMd5: this.fileMd5, table: rightData })
        if (newfile && newfile.md5) {
          await app.service('company').insertFormerYearListFile({ cid, year, response: newfile })
          this.$message.success('成功')
          this.close()
        } else {
          console.log('生成文件失败')
        }
      }
    },
  },
}
</script>
<style>
.full-page {
  position: fixed;
  top: 60px;
  left: 0;
  bottom: 0;
  width: 100%;
  padding: 15px;
  background-color: #fff;
  z-index: 1001;
}
.full-body {
  width: 100%;
  height: 100%;
  padding-bottom: 20px;
  overflow: auto;
}
.td-highlight {
  background-color: #f00;
  box-shadow: inset 0 0 0 2px #000;
  cursor: pointer;
}
.full-page-actions {
  padding-right: 25px;
  padding-bottom: 10px;
}
.correct-table > tr > th {
  max-width: 200px;
}
</style>
